// removed by extract-text-webpack-plugin
module.exports = {"label":"src-components-Checkbox__label--3f65a"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Checkbox.scss
// module id = 80
// module chunks = 0